module.exports = __webpack_public_path__ + "img/photo-05.86af5512.webp";